import { render } from "./NoLocationsTip.vue?vue&type=template&id=703cb1ae&ts=true"
import script from "./NoLocationsTip.vue?vue&type=script&lang=ts"
export * from "./NoLocationsTip.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/weather-widget-vue/weather-widget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__